module.exports = __webpack_public_path__ + "static/media/owl-laptop-study.20af28ce.png";